"use client";

import { PropsWithChildren } from "react";
import { ErrorBoundary } from "../components/error-boundary";

export function SpreadsheetTitleBoundary({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary fallback={SpreadsheetTitleFallback}>
      {children}
    </ErrorBoundary>
  );
}

function SpreadsheetTitleFallback({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return <span>Error Digest: {error.digest}</span>;
}
